import { render, staticRenderFns } from "./32.vue?vue&type=template&id=0ecc729b&scoped=true&"
var script = {}
import style0 from "./32.vue?vue&type=style&index=0&id=0ecc729b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecc729b",
  null
  
)

export default component.exports